








































































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../core/base.component';
import DashboardFounderConsultList from './components/DashboardFounderConsultList.vue';
import DashboardCompanyUserList from './components/DashboardCompanyUserList.vue';
import DashboardCompanyList from './components/DashboardCompanyList.vue';
import DashboardGraph from './components/DashboardGraph.vue';
import DashboardCityGraph from './components/DashboardCityGraph.vue';
import DashboardDeliveryConsultGraph from './components/DashboardDeliveryConsultGraph.vue';
import DashboardDeliveryConsultList from './components/DashboardDeliveryConsultList.vue';
import DashboardPaymentListGraph from './components/DashboardPaymentListGraph.vue';

@Component({
  name: 'Dashboard',
  components: {
    DashboardFounderConsultList,
    DashboardCompanyUserList,
    DashboardCompanyList,
    DashboardGraph,
    DashboardCityGraph,
    DashboardDeliveryConsultGraph,
    DashboardDeliveryConsultList,
    DashboardPaymentListGraph,
  },
})
export default class Dashboard extends BaseComponent {}
